import { ReactTFC } from "../utils/fp/missing-ts-parts";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { SOError, type PublicConfigurationT } from "@swo/shared";
import React from "react";
import {
  defaultErrorsHeadline,
  defaultErrorsParagraph,
  ErrorLogsComponent,
} from "../components/ErrorLogsComponent/ErrorLogsComponent";
import { GenericNotFoundPageLayout } from "../layouts/generic-not-found/GenericNotFoundPageLayout";
import type { GeneralTranslation } from "@swo/storefront";

export const OnPageErrorComponent: ReactTFC<{
  errors: NonEmptyArray<SOError>;
  pageId?: string;
  mode: "preview" | "published";
  generalTranslations: GeneralTranslation;
  config: PublicConfigurationT;
}> = props => {
  if (props.mode === "preview") {
    return (
      <ErrorLogsComponent
        errors={props.errors}
        pageId={props.pageId}
        config={props.config}
        headline={defaultErrorsHeadline}
        paragraph={defaultErrorsParagraph}
      />
    );
  } else {
    return <GenericNotFoundPageLayout translations={props.generalTranslations} />;
  }
};
